import EntryPage from './EntryPage';

export default EntryPage;
